module.exports = __webpack_public_path__ + "img/third-2.e20c6cc7.webp";